function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var mapObject = (obj, mapFn) => {
  var keys = Object.keys(obj);
  return keys.reduce((newObject, key) => _extends({}, newObject, {
    [key]: mapFn(key, obj[key])
  }), {});
};
export { mapObject };